import { render } from "./UnitAdminReport.vue?vue&type=template&id=5f2d93a2&scoped=true"
import script from "./UnitAdminReport.vue?vue&type=script&lang=js"
export * from "./UnitAdminReport.vue?vue&type=script&lang=js"

import "./UnitAdminReport.vue?vue&type=style&index=0&id=5f2d93a2&scoped=true&lang=css"

import exportComponent from "/Users/habeebrahman/Documents/htdocs/cdz_projects/wg-frontend-v1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f2d93a2"]])

export default __exports__